import { DetailedHTMLProps, FocusEvent, InputHTMLAttributes, KeyboardEvent, MouseEvent } from 'react';

import { BackgroundProps, Size, SpacingProps, UIProps } from '../../theme/mixins';
import { DateTimeFormat } from '../../config';
import SC from './SC';

export type HtmlInputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

export interface InputProps extends BackgroundProps, SpacingProps {
  size?: Size;
  placeholder?: boolean;
  color?: string;
}

export interface DatePickerProps extends SC<UIProps> {
  selected: string;
  internalFormat?: DateTimeFormat;
  startDate?: string;
  endDate?: string;
  minDate?: string;
  maxDate?: string;
  minTime?: string;
  maxTime?: string;
  placeholder?: string;
  dateFormat?: string | string[];
  timeFormat?: string;
  selectsStart?: boolean;
  selectsEnd?: boolean;
  showTimeSelect?: boolean;
  showTimeSelectOnly?: boolean;
  timeIntervals?: number;
  id?: string;
  onChange: (value: string | null, event: KeyboardEvent<HTMLElement> | MouseEvent<HTMLElement>) => any;
  onBlur?: (event: FocusEvent) => void;
}

export interface PhoneNumberInputProps extends SC<UIProps> {
  value: string;
  country: string;
  onChange: (result: string) => void;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => void;
  name?: string;
  id?: string;
}

export const ENTER_KEY = 13;
export const BACKSPACE_KEY = 8;
